if (!customElements.get('count-down')) {
  customElements.define(
    'count-down',
    class countDown extends HTMLElement {
      constructor() {
        super();
        this.init(this);
      }
      init(self) {
        const countDownDate = new Date(
          self.querySelector('.product-release')?.getAttribute('data-release_date')
        ).getTime();
        if (countDownDate) {
          let x = setInterval(function () {
            // Get today's date and time
            let now = new Date().getTime();
            let distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            if (days < 10) {
              days = '0' + days;
            }
            if (hours < 10) {
              hours = '0' + hours;
            }
            if (minutes < 10) {
              minutes = '0' + minutes;
            }
            if (seconds < 10) {
              seconds = '0' + seconds;
            }

            // Disaply date
            self.querySelector('#product-release__right-day').innerHTML = days;
            self.querySelector('#product-release__right-hours').innerHTML = hours;
            self.querySelector('#product-release__right-minute').innerHTML = minutes;
            self.querySelector('#product-release__right-second').innerHTML = seconds;

            self.classList.remove('hidden');
            // If the count down is finished, write some text
            if (distance < 0) {
              clearInterval(x);
              self.querySelector('.product-release').classList.add('hidden');
            }
          }, 1000);
        }
      }
    }
  );
}
